import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './login';
import Profile from './profile';
import AllUsers from './all_users';
import GenerateBill from './generate_bill'; 
import MessCut from './mess_cut';
import Bill from './bill';
import RegisterPage from './register';
import ResetPassword from './resetpassword';
import EditProfilePage from './edit_profile';
import MealAttendance from './MealAttendance'; 
import ProtectedRoute from './protectedroute';
import PaymentPage from './payment';

const App = () => {

return (
  <Routes>
    <Route path="/register" element={<RegisterPage />} />
    <Route path="/" element={<Login />} />
    <Route path="/profile" element={<Profile />} />
    <Route path="/payment-qr-details" element={<PaymentPage />} />
    <Route path="/allusers/:uid" element={
      <ProtectedRoute>
        <AllUsers />
      </ProtectedRoute>
    } />
     <Route path="/generatebill/:uid" element={
      <ProtectedRoute>
        <GenerateBill />
      </ProtectedRoute>
    } />
    <Route path="/messcut/:uid" element={<MessCut />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/login" element={<Login />} />
    <Route path="/mealattendance" element={
      <ProtectedRoute>
        <MealAttendance />
      </ProtectedRoute>
    } />
    <Route path="/bill/:uid" element={<Bill />} />
    <Route path="/unauthorized" element={<h2>Unauthorized</h2>} />
    <Route path="/editprofile" element={<EditProfilePage />} />
  </Routes>
);
};

export default App;
